<template lang="html">

  <section class="wrapper oferta-view">

    <div class="ficha-oferta-wrapper container row-start ais">

      <article class="top" v-if="!!oferta">

        <div class="breadcrumb-container row-between ais">

          <nav class="breadcrumb">
            <router-link :to="$t('enlaces.home')">Inicio</router-link>
            <router-link :to="$t('enlaces.ofertas')">Ofertas</router-link>
            <router-link :to="$t('enlaces.ofertas')">{{oferta.titulo}}</router-link>
          </nav>

          <a @click="$router.go(-1)" class="back">
            < Volver</a> </div> <div class="title-container row-start">
              <h4 v-if="!!oferta.idoferta" class="codigo">[{{oferta.idoferta}}]</h4>
              <h2 class="titulo">{{oferta.titulo}}</h2>
        </div>

        <div class="middle row-start" v-if="!!oferta">
          <h3 class="fecha" v-if="!!oferta.fecha">{{oferta.fecha}}</h3>
          <h3 class="localizacion" v-if="!!oferta.poblacion || !!oferta.provincia">
            <template v-if="!!oferta.poblacion">{{oferta.poblacion}}</template>
            <template v-if="!!oferta.poblacion && !!oferta.provincia">-</template>
            <template v-if="!!oferta.provincia">{{oferta.provincia}}</template>
          </h3>
          <h3 v-if="!!oferta.idSectorOferta" class="sector">{{dominios.sectores[oferta.idSectorOferta]}}</h3>
          <h3 class="sector" v-if="!!oferta.sector & !!!oferta.idSectorOferta">{{oferta.sector}}</h3>
          <h3 class="empresa" v-if="!!oferta.empresa">{{oferta.empresa}}</h3>
        </div>

      </article>
      <main class="main" v-if="!!oferta">

        <h3>Descripción del puesto</h3>
        <p v-html="oferta.descripcion"></p>

        <div class="tips row-start">

          <article v-if="!!oferta.fechaInicio">
            <h3>Fecha de inicio</h3>
            <p>{{oferta.fechaInicio}}</p>
          </article>

          <article v-if="!!oferta.fechaInicio">
            <h3>Fecha de fin</h3>
            <p>{{oferta.fechaFin}}</p>
          </article>

          <article v-if="!!oferta.horario">
            <h3>Horario</h3>
            <p>{{oferta.horario}}</p>
          </article>

          <article v-if="!!oferta.contrato">
            <h3>Tipo de contrato</h3>
            <p>{{dominios.contratos[oferta.contrato]}}</p>
          </article>

          <article v-if="!!oferta.formato && oferta.formato!='Desconocido'">
            <h3>Formato:</h3>
            <p>{{oferta.formato}}</p>
          </article>

          <article v-if="!!oferta.tiempoPresencial && oferta.formato=='Híbrido'">
            <h3>% tiempo presencialidad</h3>
            <p>{{oferta.tiempoPresencial}}%</p>
          </article>

          <article v-if="!!oferta.tiempoTeletrabajo && oferta.formato=='Híbrido'">
            <h3>% tiempo teletrabajo</h3>
            <p>{{oferta.tiempoTeletrabajo}}%</p>
          </article>

          <article v-if="!!oferta.ayudaEstudio">
            <h3>Ayuda al estudio (cantidad en euros brutos mensuales)</h3>
            <p>{{oferta.ayudaEstudio}}</p>
          </article>

          <article v-if="!!oferta.observacionesRemuneracion">
            <h3>Observaciones remuneración</h3>
            <p>{{oferta.observacionesRemuneracion}}</p>
          </article>

          <article v-if="!!oferta.horasDia">
            <h3>Horas al día</h3>
            <p>{{oferta.horasDia}}</p>
          </article>

          <article v-if="!!oferta.salario">
            <h3>Salario</h3>
            <p>{{dominios.salario[oferta.salario]}}</p>
          </article>

          <article v-if="!!oferta.remuneraciones">
            <h3>Otras remuneraciones</h3>
            <p>{{oferta.remuneraciones}}</p>
          </article>

          <article v-if="!!oferta.plazas">
            <h3>Vacantes</h3>
            <p>{{oferta.plazas}}</p>
          </article>

          <article v-if="!!oferta.pais">
            <h3>País</h3>
            <p>{{oferta.pais}}</p>
          </article>

        </div>

      </main>
      <aside class="aside" v-if="!!oferta">

        <div class="tips">

          <article v-if="oferta.documentos.length > 0">
            <h3>Documentación requerida</h3>
            <ul>
              <li v-for="doc in oferta.documentos">{{doc.nombre}}</li>
            </ul>
          </article>

          <article v-if="oferta.estudios_obligatorios.length > 0 || oferta.estudios_deseables.length > 0">
            <h3>Formación</h3>
            <ul>
              <li v-for="estudio in oferta.estudios_obligatorios">{{estudio.nombre}}</li>
              <li v-for="estudio in oferta.estudios_deseables">{{estudio.nombre}}</li>
            </ul>
          </article>

          <article v-if="!!oferta.experiencia">
            <h3>Experiencia</h3>
            <p v-html="dominios.experiencia[oferta.experiencia]"></p>
          </article>

          <article v-if="!!oferta.requisitos_obligatorios">
            <h3>Requisitos</h3>
            <p v-html="oferta.requisitos_obligatorios"></p>
          </article>

          <article v-if="!!oferta.requisitos_deseables">
            <h3>Aspectos valorables</h3>
            <p v-html="oferta.requisitos_deseables"></p>
          </article>

          <article v-if="!!oferta.idiomas">
            <h3>Idiomas</h3>
            <ul>
              <li v-for="idioma in oferta.idiomas">
                {{dominios.idioma[idioma.idioma]}}
                <template v-if="idioma.nivel"> {{dominios.nivelidioma[idioma.nivel]}},</template>
                {{(idioma.certificacion) ? 'Con certificación' : 'Sin certificación'}}
              </li>
            </ul>
          </article>

          <article v-if="!!oferta.programas">
            <h3>Software</h3>
            <p>{{oferta.programas}}</p>
          </article>

        </div>

      </aside>

      <div class="btn-container row-center">
        <button v-if="!!oferta.puede_inscribirse && !!!oferta.candidatura" @click="showpopup = true"
          class="btn">Inscribirme</button>
        <button v-if="!!oferta.puede_desinscribirse" @click="desinscribirse" :loading="loading"
          class="btn skull">Desinscribirse</button>
      </div>

    </div>


    <div class="loading" v-if="!!!oferta"></div>

    <popupinscripcion @inscrito="setInscrito" v-if="showpopup" @hide="showpopup = false"></popupinscripcion>

  </section>

</template>

<script lang="js">

  import popupinscripcion from '@/components/parts/popup-inscripcion';

  import { mapActions, mapGetters } from 'vuex';

  import router from '@/router';

  export default {
    name: 'ficha-oferta',
    mounted() {
      if (!!this.$route.params.id) {
        this.getoferta();
      } else {
        router.push({ name: 'ofertas' });
      }
    },
    data() {
      return {
        oferta: '',
        showpopup: false,
        loading: false
      }
    },
    methods: {
      ...mapActions(['requestOferta', 'requestDesincripcion']),
      getoferta() {
        this.requestOferta(this.$route.params.id).then(r => {
          this.oferta = r;
          document.title = this.oferta.titulo;
        });
      },
      setInscrito() {
        this.oferta.candidatura = true;
        this.oferta.puede_inscribirse = false;
        this.oferta.puede_desinscribirse = true;
        this.showpopup = false
      },
      desinscribirse() {
        this.loading = true;
        this.requestDesincripcion(this.$route.params.id).then(r => {
          this.loading = false;
          if (r) {
            this.oferta.puede_inscribirse = true;
            this.oferta.puede_desinscribirse = true;
            this.oferta.candidatura = false;
          }
        });
      }

    },
    components: {
      popupinscripcion
    },
    computed: {
      ...mapGetters({
        dominios: 'getDominios'
      })
    },
    watch: {
      '$route'() {
        this.getoferta();
      }
    }
  }
</script>

<style scoped lang="scss">
  .btn {
    transition: 0s;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/ficha-oferta.vue